<agpr-take-over-panel
    id="onlineBoostConfirmationDialogComponent"
    class="agpr-onlineBoostConfirmationDialogComponent"
    [header]="'Distribution.onlineBoost' | localize"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="cancel()"
    [width]="40"
>
    <div class='agpr-onlineBoostConfirmationDialogComponent-content'>
        <div class="agpr-onlineBoostConfirmationDialogComponent-message">
            <span class="agpr-onlineBoostConfirmationDialogComponent-message-icon fa-duotone fa-regular fa-bolt"></span>
            <h2 class="agpr-onlineBoostConfirmationDialogComponent-message-header" [innerHtml]="'Distribution.onlineBoost.dialog.heading' | localize"></h2>
            <span>{{'Distribution.onlineBoost.dialog.message' | localize}}</span>
            <a class="agpr-onlineBoostConfirmationDialogComponent-message-link" href="http://help.agilitypr.com/en/articles/5679879-online-boost-service-faq" target="_blank">{{'Discover.onlineBoost.confirmAction.detail.link' | localize}}</a>
        </div>

        <div class="agpr-onlineBoostConfirmationDialogComponent-disclaimer-container">
            <agpr-checkbox
                id="onlineBoostConfirmationDialogComponent_checkbox"
                [binary]="true"
                [(ngModel)]="hasAgreed"
            >
                <span [innerHTML]="'Discover.onlineBoost.confirmAction.disclaimer' | localize"></span>
            </agpr-checkbox>
        </div>
    </div>
    <ng-template #takeOverFooterLeft>
        <agpr-button
            (click)="cancel()"
            [label]="'close'"
            id="onlineBoostConfirmationDialogComponent.cancelButton"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            (click)="ok()"
            [label]="'Discover.onlineBoost.confirmAction.agree'"
            [style]="buttonTypes.primary"
            id="onlineBoostConfirmationDialogComponent.agreeButton"
            [disabled]="!hasAgreed"
            [tooltip]="hasAgreed ? '' : 'Discover.amplify.postDistribution.confirm.disabled'"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
